<div class="row edit-top-informations">
  <div class="col-sm" *ngIf="actualite.Creation">Création : {{ actualite.Creation | date: 'dd MMMM yyyy' }}</div>
</div>

<div class="tab-content tab-content-edit-actualite" style="min-height: 400px; min-height: calc(100vh - 400px); max-height: 600px; max-height: calc(100vh - 300px); margin-top: 16px; margin-bottom: 16px; overflow-x: hidden; overflow-y: auto">
  <div class="tab-pane active" id="general" role="tabpanel" aria-labelledby="general-tab">
    <div class="form-group form-group-sm row">
      <div class="col-sm-12" style="text-align: center; vertical-align: middle">
        <h1>{{ actualite.Libelle }}</h1>
      </div>
    </div>

    <div class="form-group row" style="text-align: center; vertical-align: middle; margin-bottom: 18px" *ngIf="actualite.LogoUrl">
      <div class="col-sm-12">
        <img src="{{ actualite.LogoUrl }}" style="max-height: 500px; max-width: 500px" />
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-12" style="margin-right: 5px">
        <editor [disabled]="true" [init]="tinymceInit" [(ngModel)]="actualite.Contenu" id="contenuVisu" name="contenuVisu" ngDefaultControl></editor>
      </div>
    </div>
  </div>
</div>
<div class="form-group row">
  <div class="col-sm-12 text-right">
    <button type="button" class="btn btn-secondary" (click)="cancel()"><i class="fa fa-ban" aria-hidden="true"></i> &nbsp; Fermer <aide code="home.actualite-view.component.fermer"></aide></button>
  </div>
</div>
